import { useGetActiveSpecialDealsQuery } from "store/apis/specialDealsAPI"

export const useSpecialDeals = (skip?: boolean) => {
  const { data: specialDeal, isLoading: isSpecialDealsLoading } =
    useGetActiveSpecialDealsQuery(undefined, { skip })

  return { specialDeal, isSpecialDealsLoading }
}
